import { compose } from 'recompose';

import { withQueryOptions } from '../../shared/containers';
import { Table } from './Component';

export default compose(withQueryOptions)(Table);
